<template>
  <div>
      <b-navbar toggleable="md" type="dark">
        <b-navbar-brand href="#"><img src="/img/logo.png" alt="ESPACE'COM" style="width: 10em;"></b-navbar-brand>
        <b-collapse id="navbar" is-nav>
          <b-navbar-nav>
            <b-nav-item v-for="item in Menu" :key="item.key" :href="item.href">
              <div style="display: flex; flex-direction: column;align-items: center;justify-content: center;">
                <i :class="item.icon"></i>
                <span>{{ item.title }}</span>
              </div>
            </b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item size="md" class="mr-sm-2" right>{{ time }}</b-nav-item>
            <b-nav-item :to="'#'" size="sm" class="mr-sm-2" right><span class="far fa-user"></span> {{ info.prenom+" "+info.nom }}</b-nav-item>
            <b-nav-item v-on:click="disconnect()" size="sm" class="mr-sm-2" right><span class="fas fa-sign-out-alt" ></span></b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <!-- <sidebar-menu :menu="verticalMenu" class="sidebar-menu-admin" collapsed></sidebar-menu> -->
  </div>
</template>
<script>
import script from '../../script/script.js';
import scriptTiers from '../../script/script_tiers.js';
var moment = require('moment');
export default {
  data() {
    return {
      active: true,
      time: moment().format('LLLL'),
      intervalTime:null,
      Menu:[
        {
          href:"/indexAdmin",
          title:"ACCUEIL",
          key:"accueil",
          icon:'fas fa-home'
        },
        {
          href:"/comptabilite/exportVenteSage",
          title:"EXPORT SAGE",
          key:"sage",
          icon:'fas fa-calculator',
        },
        {
          href:"/comptabilite/extractTime",
          title:"EXTRACT TIME",
          key:"time",
          icon:'fas fa-calculator',
        },
      ]
    }
  },
  beforeCreate(){
    moment.locale('fr');
  },
  mounted(){
    this.loadingInfo();
    this.intervalTime = setInterval(() => this.time = moment().format('LLLL'), 500);
  },
  beforeDestroy(){
    clearInterval(this.intervalTime);
  },
  methods: {
    disconnect: script.disconnect,
    loadingInfo: script.loadingInfo,
    loadingClient: scriptTiers.loadingClient,
    linkGen (pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    }
  },
  components: {
  },
  computed:{
		info(){
			return this.$store.state.info
		}
	}
  
}
</script>

<style>
    #navbar .btn-secondary, #navbar .btn-secondary:hover, #navbar .btn-secondary:active, #navbar .btn-secondary:focus, #navbar .btn-secondary:not(:disabled):not(.disabled).active, #navbar .btn-secondary:not(:disabled):not(.disabled):active, #navbar .show>.btn-secondary.dropdown-toggle{
		background-color: transparent;
		border-color: transparent;
		box-shadow: none;
	}

	.navbar-dark .navbar-nav .nav-link {
		color: white;
	}

	.navbar{
		height: 100%;
		background-color:#24AAE1;
	}

	.dropdown:before, .dropdown.active:before{
		content: '';
	}
</style>

<style scoped>

</style>
